import { faIdCard, faToggleOn } from '@fortawesome/pro-light-svg-icons'
import { faSalesforce } from '@fortawesome/free-brands-svg-icons'

import { generateUrls } from '@hooks/useProvider'

import { ProviderModel } from '@models/types'

interface GenerateTabBarItemsProps {
  isAdmin: boolean,
  provider: Partial<ProviderModel>,
}

const generateTabBarItems = (props: GenerateTabBarItemsProps) => {
  const { isAdmin, provider } = props

  const urls = generateUrls(provider)
  const { editProviderRelationsUrl, editProviderUrl, providerSalesforceDetailsUrl } = urls

  const hasSalesforceId = !!provider?.salesforce_id

  return [
    {
      icon: faIdCard,
      href: editProviderUrl,
      key: 'details',
      title: provider?.short_name || 'Provider Details',
    },
    {
      icon: faToggleOn,
      href: editProviderRelationsUrl,
      key: 'permissions',
      title: 'Provider Relations',
    },
    {
      icon: faSalesforce,
      href: providerSalesforceDetailsUrl,
      hidden: !hasSalesforceId || !isAdmin,
      key: 'salesforceDetails',
      title: 'Salesforce Details',
    },
  ]
}

export default generateTabBarItems
